module.exports = __webpack_public_path__ + "img/itx-file-type-odp.8a709754.svg";